import Vue from "vue";
import Router from "vue-router";

import NProgress from "nprogress";

import store from "@/store";
import routes from "./routes";

Vue.use(Router);

const router = new Router({
  base: "/",
  mode: "hash",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// router gards
router.beforeEach((to, from, next) => {
  NProgress.configure({
    minimum: 0.25,
    trickle: true,
    trickleSpeed: 500,
    showSpinner: Vue.prototype.$vuetify.breakpoint.xs ? true : false
  });
  NProgress.start();
  // default for layout
  if (!to.meta.error) store.commit("SET_LAYOUT", to.meta.public);
  // Auth navigation guard.
  if (!to.meta.public && !store.state.auth.authenticated) {
    next({ path: "/", query: { redirect: to.fullPath } });
  } else {
    // check role access
    if (to.meta.role) {
      if (!to.meta.role.includes(store.state.auth.role) && !to.query.id) {
        next({ name: "AccessDenied" });
      } else next();
    } else next();
  }
});

router.afterEach(to => {
  NProgress.done();
  store.dispatch("sistem/GET_SISTEM").then(() => {
    let title = to.meta.title ? to.meta.title : to.name;
    title += " - " + store.state.sistem.sistem.app_title;
    document.title = title;
  });
});

export default router;
